import Footer from '@/components/ui/footer';
import Header from '@/components/ui/header';
import React, { useEffect } from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '@/css/frontend.css';
import { CartProvider } from '@/context/CartContext';
import { Toaster } from 'sonner';
import { WishlistProvider } from '@/context/WishlistContext';
import TawkChat from '@/lib/talkchat';

import 'swiper/swiper-bundle.css';



import AOS from 'aos';
import 'aos/dist/aos.css';


const FrontendLayout = ({ children }: { children: React.ReactNode }) => {

    useEffect(() => {
        import('bootstrap/dist/js/bootstrap.bundle.min.js');
        
        AOS.init({
            duration: 1500,
        });

    }, []);

    return (
        <div>
            <CartProvider>
                <WishlistProvider>
                    <Toaster position="top-right" richColors />
                    <Header />
                    {children}
                    <TawkChat />
                    <Footer />
                </WishlistProvider>
            </CartProvider>
        </div>
    );
};

export default FrontendLayout;
